import React from 'react';
import './WhiteSpace.scss';

export interface WhiteSpaceInputs {
    space: string;
}

export const WhiteSpace = ({ inputs }: { inputs: WhiteSpaceInputs }) => {
    const sizes = {
        '10px': `10`,
        '20px': `20`,
        '30px': `30`,
    };
    const sizeClass = sizes[inputs.space] || `10`; // default if size is not supported

    return <div className={`white-space white-space--${sizeClass}`} />;
};
